// import Img2 from "../images/testimonials/pfp1.jpg";
// import Img3 from "../images/testimonials/pfp2.jpg";
import Img4 from "../images/testimonials/nikini.png";
import Img5 from "../images/testimonials/cus2.png";


function Testimonials() {
  return (
    <>
      <section className="testimonials-section">
        <div className="container">
          <div className="testimonials-content">
            <div className="testimonials-content__title">
              <h4>Reviewed by People</h4>
              <h2>Client's Testimonials</h2>
              <p>
                Discover the positive impact we've made on the our clients by
                reading through their testimonials. Our clients have experienced
                our service and results, and they're eager to share their
                positive experiences with you.
              </p>
            </div>

            <div className="all-testimonials">
              <div className="all-testimonials__box">
                <span className="quotes-icon">
                  <i className="fa-solid fa-quote-right"></i>
                </span>
                <p>
                  " Thank you very much for the service. It was perfect.
                  The owner is a very nice man. The car was in a good condition. The car was big and I have no experience to drive such a car.
                  So the owner has explained all the details about the car to me very patiently.
                  We returned the car when it was late. We had a baby with us and the owner was so nice so he even drove us to the hotel. And we did not have to walk back."
                </p>
                <div className="all-testimonials__box__name">
                  <div className="all-testimonials__box__name__profile">
                    <img src={Img5} alt="user_img" />
                    <span>
                      <h4>Мария Карпухина</h4>
                      <p>Russia</p>
                    </span>
                  </div>
                </div>
              </div>

              <div className="all-testimonials__box box-2">
                <span className="quotes-icon">
                  <i className="fa-solid fa-quote-right"></i>
                </span>
                <p>
                  "The vehicle was in top-notch condition. The rental process was hassle-free, and the prices were reasonable."
                </p>
                <div className="all-testimonials__box__name">
                  <div className="all-testimonials__box__name__profile">
                    <img src={Img4} alt="user_img" />
                    <span>
                      <h4>Nikini Fernando</h4>
                      <p>Sri Lanka</p>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Testimonials;
